:host {
  --jump-range-track-height: 4px;
  --jump-range-thumb-color: var(--neutral-white, #ffffff);
  --jump-range-thumb-size: 18px;
  --jump-range-fill-color: var(--secondary-standard, #5e79ba);
  --jump-range-track-color: var(--gray-ultralight, #f8f8f8);

  display: block;
  width: 100%;
}

:host(.is-disabled) {
  opacity: 0.5;
  cursor: not-allowed;
  --jump-range-fill-color: var(--gray-light, #e0e0e0);
}

.label-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  font-size: 0.9em;
  color: #333;
}

.slider-container {
  position: relative;
  height: var(--jump-range-thumb-size);
  display: flex;
  align-items: center;
}

// Traccia visiva di background
.slider-track,
.slider-fill {
  position: absolute;
  left: 0;
  height: var(--jump-range-track-height);
  border-radius: var(--jump-range-track-height);
  width: 100%;
}

.slider-track {
  background-color: var(--jump-range-track-color);
  z-index: 1;
}

.slider-fill {
  background-color: var(--jump-range-fill-color);
  z-index: 2;
}

// Stili per gli input nativi
.range-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: absolute;
  width: 100%;
  height: var(--jump-range-thumb-size);
  background: transparent;
  pointer-events: none; // Permette di cliccare attraverso l'input
  margin: 0;
  z-index: 3;
}

// Stili per il selettore (thumb)
// Il pointer-events qui è fondamentale per rendere solo il thumb cliccabile
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: var(--jump-range-thumb-size);
  width: var(--jump-range-thumb-size);
  border-radius: 50%;
  background: var(--jump-range-thumb-color);
  border: 1px solid #ccc;
  cursor: pointer;
  pointer-events: auto;
  margin-top: calc((var(--jump-range-thumb-size) - var(--jump-range-track-height)) / -2);
}

input[type="range"]::-moz-range-thumb {
  -moz-appearance: none;
  height: var(--jump-range-thumb-size);
  width: var(--jump-range-thumb-size);
  border-radius: 50%;
  background: var(--jump-range-thumb-color);
  border: 1px solid #ccc;
  cursor: pointer;
  pointer-events: auto;
}

// Rende la traccia nativa dell'input invisibile
input[type="range"]::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  height: var(--jump-range-track-height);
  background: transparent;
  border: none;
}

input[type="range"]::-moz-range-track {
  -moz-appearance: none;
  height: var(--jump-range-track-height);
  background: transparent;
  border: none;
}